export class Rate
{
	rateId: number;
	rateDate: Date;
}
